module.exports = __webpack_public_path__ + "img/mobile_Internet.22f2589e.svg";